import { reactive, ref, unref } from 'vue';
import { defineStore } from 'pinia';
import { IStorage } from './storage.interface';



export default defineStore('storage', () => {
  const storage = reactive<IStorage>({});
  const isFormValid = ref<boolean>(true);
  function store(prop, value) {  //actions
    storage[prop] = value;
  }

  function getAll() {
    return JSON.parse(JSON.stringify(storage));
  }
  return { valid: isFormValid, store, getAll }
})
// export default useCompanyStore;